export enum ToastMessage {
  EmailSent = 'The email has been sent',
  InformationSaved = 'Information saved.',
  DefaultError = 'Something went wrong. Please try again later.',
  MainContactCannotBeDeleted = 'Main Contact cannot be deleted',
  UploadedDocument = 'The documents have been uploaded',
  PasswordChangedSuccessfully = 'Password has been successfully changed.',
  UpdatedEmail = 'The email has been updated.',
  UserCreated = 'User has been successfully created.',
  UserUpdated = 'User has been successfully updated.',
  RoleCreated = 'Role has been successfully created.',
  RoleUpdated = 'Role has been successfully updated.',
  RoleDeleted = 'Role has been successfully deleted.',
  NotificationsCreate = 'Notifications has been successfully created.',
  NotificationsUpdated = 'Notifications has been successfully updated.',
  MdaSigned = 'Master Dealer Agreement has been signed!',
  YouCanChangeYourOwnEmailOnMyProfilePage = 'You can change your own email on My Profile page',
  RestrictedZipCode = 'Address provided is not in the U.S. 50 states or D.C.',
  MaxPercentageOwnedLimitExceeded = 'Total Percentage For All Owners Must Not Exceed 100%.',
  EmailsMustBeUniqueForEachOwnerAndSalesperson = 'Emails must be unique for each Owner/Salesperson',
  EmailAlreadyUsedByAnotherUser = 'Email already used by another user',
  YourRequestToScheduleCallReceived = 'Thank you! Your request to schedule an intake call has been received. Our team will contact you soon.',
}
